import { IAppState } from "app/model"
import { Action, Reducer } from "redux"
import { ACTIONS, IAppActionSetContext } from "./actions"
import { getDefaultAppState } from "./state"

export const appReducer: Reducer<IAppState, Action> = (state: IAppState | undefined, action: Action): IAppState => {
  if (!state) {
    state = getDefaultAppState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      return {
        ...state,
        isInitializating: false,
        hasInitError: false
      }
    }

    case ACTIONS.APP_STOP_INIT_DATA: {
      return {
        ...state,
        isInitializating: false,
        hasInitError: false
      }
    }

    case ACTIONS.APP_INIT_DATA_START: {
      return {
        ...state,
        isInitializating: true,
        hasInitError: false
      }
    }

    case ACTIONS.APP_INIT_DATA_ERROR: {
      return {
        ...state,
        isInitializating: false,
        hasInitError: true
      }
    }

    case ACTIONS.APP_SET_ACTIVE_CONTEXT: {
      const { context } = action as IAppActionSetContext
      return {
        ...state,
        activeContext: context
      }
    }

    default: {
      return state
    }
  }
}
